/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Draftcleared1Inputs */

const en_draftcleared1 = /** @type {(inputs: Draftcleared1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Draft cleared`)
};

const de_draftcleared1 = /** @type {(inputs: Draftcleared1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entwurf gelöscht`)
};

/**
* | output |
* | --- |
* | "Draft cleared" |
*
* @param {Draftcleared1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const draftcleared1 = /** @type {((inputs?: Draftcleared1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draftcleared1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_draftcleared1(inputs)
	return de_draftcleared1(inputs)
});
export { draftcleared1 as "draftCleared" }